import { useOrderContactInfo } from 'checkout/hooks';
import React from 'react';
import { isValidContactInfo } from 'utilities/validators';
import './UpdateSenderInformation.scss';
export function UpdateSenderInformation({ setShouldDisableCheckout }) {
    const orderContactInfo = useOrderContactInfo();
    const contactInfoValid = isValidContactInfo(orderContactInfo);
    setShouldDisableCheckout(!contactInfoValid.valid);
    return (React.createElement("div", { className: 'update-sender-information' }, !contactInfoValid.valid && React.createElement("div", { className: 'update-sender-information__error' }, "Du m\u00E5 oppdatere avsenderinformasjon f\u00F8r du kan gjennomf\u00F8re kj\u00F8pet.")));
}
